import React from "react";

export default function Shop() {
    return (
      <div>
        <h1>Shop</h1>
      </div>
    );
  }